import type { RouteObject } from "react-router-dom";
import AppLayout from "@/components/feature/AppLayout";
import Login from "@/pages/login/page";
import Home from "@/pages/home/page";
import Datasets from "@/pages/datasets/page";
import ModelSettings from "@/pages/model/settings/page";
import Results from "@/pages/results/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/",
    element: <AppLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "datasets", element: <Datasets /> },
      { path: "model/:id/settings", element: <ModelSettings /> },
      { path: "results", element: <Results /> },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;